import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index/index.vue'
import search from '../views/search/search.vue'
import supplier from '../views/supplier/supplier.vue'
Vue.use(Router)
export default new Router({
	routes:[{
		
		path:'/',
		name: 'index',
		component: index
		
	},
	{
		
		path:'/search',
		name: 'search',
		component: search
		
	},
	{
		
		path:'/supplier',
		name: 'supplier',
		component: supplier
		
	}
	]
	
	
})